import Params from './ParamsService'

export const ParamsService = Params
